import { render, staticRenderFns } from "./FlushingDetailTemplate.vue?vue&type=template&id=799759f4&scoped=true"
import script from "./FlushingDetailTemplate.vue?vue&type=script&lang=js"
export * from "./FlushingDetailTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799759f4",
  null
  
)

export default component.exports